"use strict";

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ZoteroData;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.array.sort.js");

require("core-js/modules/es.object.keys.js");

var _api = require("./api");

var _includes2 = _interopRequireDefault(require("lodash/includes"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Store, Encapsulate and Manipulate Zotero API data
 * @param {Object[]} data   - Zotero API data to encapsulate
 * @param {Object} [config] - ZoteroPublications config
 */
function ZoteroData(data, config) {
  var _this = this;

  this.raw = this.data = (0, _api.processResponse)(data, config);
  this.grouped = _constants.GROUPED_NONE;
  Object.defineProperty(this, 'length', {
    enumerable: false,
    configurable: false,
    get: function get() {
      return _this.raw.length || 0;
    }
  });
}
/**
 * Group data by type
 * @param  {String|String[]} [expand=[]] - List of types which should appear pre-expanded.
 *                                         Alternatively string "all" is accepted.
 */


ZoteroData.prototype.groupByType = function (expand) {
  var groupedData = {};
  expand = expand || [];

  for (var i = this.raw.length; i--;) {
    var item = this.raw[i];

    if (!groupedData[item.data.itemType]) {
      groupedData[item.data.itemType] = [];
    }

    groupedData[item.data.itemType].unshift(item);
    groupedData[item.data.itemType][_constants.GROUP_EXPANDED_SUMBOL] = expand === 'all' || (0, _includes2.default)(expand, item.data.itemType);
  }

  this.data = groupedData;
  this.grouped = _constants.GROUPED_BY_TYPE;
};
/**
 * Group data by top-level collections
 */


ZoteroData.prototype.groupByCollections = function () {
  throw new Error('groupByCollections is not implemented yet.');
};
/**
 * Custom iterator to allow for..of interation regardless of whether data is grouped or not.
 * For ungrouped data each interation returns single Zotero item
 * For grouped data each iternation returns a group of Zotero items. Additionaly group name
 * is available under GROUP_TITLE Symbol
 */


ZoteroData.prototype[Symbol.iterator] = /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
  var keys, _iterator, _step, key, group, _iterator2, _step2, value;

  return regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!this.grouped) {
            _context.next = 23;
            break;
          }

          keys = Object.keys(this.data).sort();
          _iterator = _createForOfIteratorHelper(keys);
          _context.prev = 3;

          _iterator.s();

        case 5:
          if ((_step = _iterator.n()).done) {
            _context.next = 13;
            break;
          }

          key = _step.value;
          group = this.data[key];
          group[_constants.GROUP_TITLE] = key;
          _context.next = 11;
          return group;

        case 11:
          _context.next = 5;
          break;

        case 13:
          _context.next = 18;
          break;

        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](3);

          _iterator.e(_context.t0);

        case 18:
          _context.prev = 18;

          _iterator.f();

          return _context.finish(18);

        case 21:
          _context.next = 40;
          break;

        case 23:
          _iterator2 = _createForOfIteratorHelper(this.data);
          _context.prev = 24;

          _iterator2.s();

        case 26:
          if ((_step2 = _iterator2.n()).done) {
            _context.next = 32;
            break;
          }

          value = _step2.value;
          _context.next = 30;
          return value;

        case 30:
          _context.next = 26;
          break;

        case 32:
          _context.next = 37;
          break;

        case 34:
          _context.prev = 34;
          _context.t1 = _context["catch"](24);

          _iterator2.e(_context.t1);

        case 37:
          _context.prev = 37;

          _iterator2.f();

          return _context.finish(37);

        case 40:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, this, [[3, 15, 18, 21], [24, 34, 37, 40]]);
});